[
  {
    "id": "MET-E8-L305-001",
    "module": "Metriek",
    "difficulty": 305,
    "question": "Een doosje is 5 cm bij 5 cm bij 5 cm. Hoeveel passen er in een kist van 1 m³?",
    "options": ["8.000", "1.000", "200", "4.000"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-DOOSJES-KIST",
    "explanation": "Per richting: 100 cm : 5 cm = 20. Totaal: 20 × 20 × 20 = 8.000 doosjes.",
    "distractorExplanations": {
      "1": "Je deed 10 × 10 × 10.",
      "2": "Je deed 1.000.000 : 5.000.",
      "3": "Je deed 20 × 20 × 10."
    }
  },
  {
    "id": "MET-E8-L305-002",
    "module": "Metriek",
    "difficulty": 305,
    "question": "Reken om: 3,5 are = ... cm²",
    "options": ["3.500.000 cm²", "350.000 cm²", "35.000 cm²", "350 cm²"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-ARE-CM2",
    "explanation": "1 are = 100 m² = 1.000.000 cm². 3,5 × 1.000.000 = 3.500.000 cm².",
    "distractorExplanations": {
      "1": "Een nul te weinig.",
      "2": "Twee nullen te weinig.",
      "3": "Vier nullen te weinig."
    }
  },
  {
    "id": "MET-E8-L305-003",
    "module": "Metriek",
    "difficulty": 305,
    "question": "De omtrek van een wiel is 2,5 meter. Hoeveel km heeft hij afgelegd na 4.000 omwentelingen?",
    "options": ["10 km", "100 km", "1 km", "4 km"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "omtrek",
    "subSkill": "omtrek",
    "familyId": "MET-AFSTAND-WIEL",
    "explanation": "4.000 × 2,5 = 10.000 meter = 10 km.",
    "distractorExplanations": {
      "1": "Je deed ×10.",
      "2": "Je deed ÷10.",
      "3": "Schattingsfout."
    }
  },
  {
    "id": "MET-E8-L305-004",
    "module": "Metriek",
    "difficulty": 305,
    "question": "Hoeveel weegt 500 liter water?",
    "options": ["500 kg", "50 kg", "5 kg", "5.000 kg"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-WATER-KG",
    "explanation": "1 liter water weegt 1 kg. 500 liter weegt 500 kg.",
    "distractorExplanations": {
      "1": "Je deelde door 10.",
      "2": "Je deelde door 100.",
      "3": "Je deed ×10."
    }
  },
  {
    "id": "MET-E8-L305-005",
    "module": "Metriek",
    "difficulty": 305,
    "question": "Reken om: 0,004 m³ = ... cl",
    "options": ["400 cl", "40 cl", "4 cl", "4.000 cl"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-M3-CL",
    "explanation": "0,004 m³ = 4 liter = 400 cl.",
    "distractorExplanations": {
      "1": "Dat is 4 dl.",
      "2": "Dat is 40 ml.",
      "3": "Dat is 40 liter."
    }
  },
  {
    "id": "MET-E8-L305-006",
    "module": "Metriek",
    "difficulty": 305,
    "question": "Een kaart heeft schaal 1 : 200.000. Twee steden liggen 6 cm uit elkaar op de kaart. Hoeveel km is dat?",
    "options": ["12 km", "120 km", "1,2 km", "6 km"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid_tijd",
    "subSkill": "schaal",
    "familyId": "MET-SCHAAL-E8",
    "explanation": "6 cm × 200.000 = 1.200.000 cm = 12.000 m = 12 km.",
    "distractorExplanations": {
      "1": "Je maakte een fout bij het omrekenen.",
      "2": "Je deelde door 200.000 in plaats van te vermenigvuldigen.",
      "3": "Je vergat de schaal toe te passen."
    }
  },
  {
    "id": "MET-E8-L305-007",
    "module": "Metriek",
    "difficulty": 305,
    "question": "Een cilinder heeft een straal van 10 cm en een hoogte van 15 cm. Hoeveel liter past erin? (π = 3,14)",
    "options": ["4,71 liter", "47,1 liter", "0,471 liter", "471 liter"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-CILINDER-E8",
    "explanation": "Grondvlak = π × r² = 3,14 × 100 = 314 cm². Inhoud = 314 × 15 = 4.710 cm³ = 4,71 liter.",
    "distractorExplanations": {
      "1": "Je vergat te delen door 1.000.",
      "2": "Je deelde door 10.000.",
      "3": "Je deed 4.710 × 100."
    }
  },
  {
    "id": "MET-E8-L305-008",
    "module": "Metriek",
    "difficulty": 305,
    "question": "Een hardloper loopt 100 meter in 10 seconden. Hoeveel km/u is dat?",
    "options": ["36 km/u", "10 km/u", "100 km/u", "60 km/u"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid_tijd",
    "subSkill": "snelheid",
    "familyId": "MET-SPRINT-KMU",
    "explanation": "100 m in 10 s = 10 m/s. Van m/s naar km/u: ×3,6. 10 × 3,6 = 36 km/u.",
    "distractorExplanations": {
      "1": "Dat is de snelheid in m/s.",
      "2": "Dat is de afstand in meters.",
      "3": "Schattingsfout."
    }
  },
  {
    "id": "MET-E8-L305-009",
    "module": "Metriek",
    "difficulty": 305,
    "question": "Een bak van 1,5 m × 0,8 m × 0,6 m is voor 60% gevuld. Hoeveel liter water zit erin?",
    "options": ["432 liter", "720 liter", "288 liter", "1.200 liter"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-BAK-60",
    "explanation": "Totaal: 1,5 × 0,8 × 0,6 = 0,72 m³ = 720 liter. 60%: 0,6 × 720 = 432 liter.",
    "distractorExplanations": {
      "1": "Dat is 100% gevuld.",
      "2": "Dat is 40% gevuld.",
      "3": "Je vergat het percentage toe te passen."
    }
  },
  {
    "id": "MET-E8-L305-010",
    "module": "Metriek",
    "difficulty": 305,
    "question": "Hoeveel ton is 4.250 kg?",
    "options": ["4,25 ton", "42,5 ton", "0,425 ton", "425 ton"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-KG-TON-E8",
    "explanation": "1 ton = 1.000 kg. 4.250 : 1.000 = 4,25 ton.",
    "distractorExplanations": {
      "1": "Je deelde door 100.",
      "2": "Je deelde door 10.000.",
      "3": "Je deelde door 10."
    }
  },
  {
    "id": "MET-E8-L305-011",
    "module": "Metriek",
    "difficulty": 305,
    "question": "Een tuin is 0,08 hectare. Hoeveel vierkante meter is dat?",
    "options": ["800 m²", "80 m²", "8.000 m²", "8 m²"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-HA-M2-E8",
    "explanation": "1 ha = 10.000 m². 0,08 × 10.000 = 800 m².",
    "distractorExplanations": {
      "1": "Je deed ×1.000.",
      "2": "Je deed ×100.000.",
      "3": "Je deed ×100."
    }
  },
  {
    "id": "MET-E8-L305-012",
    "module": "Metriek",
    "difficulty": 305,
    "question": "Reken om: 0,025 m³ = ... dl",
    "options": ["250 dl", "25 dl", "2.500 dl", "2,5 dl"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-M3-DL",
    "explanation": "0,025 m³ = 25 liter = 250 dl.",
    "distractorExplanations": {
      "1": "Je vergat om te rekenen van liter naar dl.",
      "2": "Je deed 25 × 100.",
      "3": "Je deed 25 : 10."
    }
  },
  {
    "id": "MET-E8-L305-013",
    "module": "Metriek",
    "difficulty": 305,
    "question": "Een blok hout is 30 cm × 20 cm × 10 cm. Hout weegt 0,6 kg per dm³. Hoeveel gram weegt het blok?",
    "options": ["3.600 g", "360 g", "36.000 g", "600 g"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-SG-HOUT",
    "explanation": "Inhoud: 30 × 20 × 10 = 6.000 cm³ = 6 dm³. 6 × 0,6 = 3,6 kg = 3.600 g.",
    "distractorExplanations": {
      "1": "Je deed 0,6 dm³ in plaats van 6 dm³.",
      "2": "Je deed 60 dm³.",
      "3": "Je deed 1 dm³."
    }
  },
  {
    "id": "MET-E8-L305-014",
    "module": "Metriek",
    "difficulty": 305,
    "question": "De omtrek van een cirkel is 94,2 cm. Wat is de straal? (π = 3,14)",
    "options": ["15 cm", "30 cm", "7,5 cm", "47,1 cm"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "omtrek",
    "subSkill": "omtrek",
    "familyId": "MET-CIRKEL-STRAAL-E8",
    "explanation": "Omtrek = 2 × π × r. 94,2 = 6,28 × r. r = 94,2 : 6,28 = 15 cm.",
    "distractorExplanations": {
      "1": "Dat is de diameter.",
      "2": "Je deed 94,2 : 12,56.",
      "3": "Dat is de halve omtrek."
    }
  },
  {
    "id": "MET-E8-L305-015",
    "module": "Metriek",
    "difficulty": 305,
    "question": "Een trein rijdt 200 km in 1 uur en 20 minuten. Wat is de gemiddelde snelheid in km/u?",
    "options": ["150 km/u", "200 km/u", "160 km/u", "120 km/u"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid_tijd",
    "subSkill": "snelheid",
    "familyId": "MET-SNELHEID-GEM",
    "explanation": "1 uur en 20 minuten = $1\\frac{1}{3}$ uur = $\\frac{4}{3}$ uur. Snelheid = 200 : $\\frac{4}{3}$ = 200 × $\\frac{3}{4}$ = 150 km/u.",
    "distractorExplanations": {
      "1": "Dat is als de trein 1 uur deed.",
      "2": "Je deed 200 : 1,25.",
      "3": "Je deed 200 : $\\frac{5}{3}$."
    }
  }
]